import page from 'page'
import appStarterPg from '../../config/app-starter-pg.js'
import { browserAppAccount } from '../../helpers/app-data-loaders/app-account.js'
import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'
import { contentElementId } from '../../config/config.js'

import { showPageAppAccount } from './app-account/index.js'
import { showPageConnectXero } from './pg-connect-xero/index.js'
import { showPageEntitiesPG } from './entities/index.js'
import { showPageDataSyncsPG } from './data-syncs/index.js'
import { showPageChartOfAccountsPG } from './charts-of-accounts/index.js'
import { showPageCurrenciesPG } from './pg-currencies/index.js'
import { showPageTrackingsPG } from './pg-trackings/index.js'

export function setupAccountRoutes (baseRoute) {
  page(`${baseRoute}/acc/:appAccountId`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId
    })
    showPageAppAccount({
      appAccountId,
      browserAppAccount,
      browserAppUser,
      containerElementId: contentElementId
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-xero`, async function (context) {
    console.log(`${baseRoute}/a/:appAccountId/manage-xero`)
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true
    })

    // Keep track of the appAccountId for the /xero-connected page (Xero Callback needs to be a clean url (maybe could pass a ?query param ... but not so important: localStorage is fine))
    localStorage.setItem('appAccountId', appAccountId)

    const newXeroConnection = localStorage.getItem('newXeroConnection')
    localStorage.removeItem('newXeroConnection')

    showPageConnectXero({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount,
      newXeroConnection
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-entities`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId
    })

    showPageEntitiesPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-data-syncs`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true
    })

    showPageDataSyncsPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount,
      appAccountId
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-charts-of-accounts`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId
    })

    showPageChartOfAccountsPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-currencies`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId
    })

    showPageCurrenciesPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  page(`${baseRoute}/a/:appAccountId/manage-trackings`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeTrackings: true
    })

    showPageTrackingsPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })
}
